import { Draft, PayloadAction } from '@reduxjs/toolkit';
import EPdfType from 'enums/pdfType';
import EPlanTypes from 'enums/planTypes';
import EUserTypes from 'enums/userTypes';

import { IAuthData } from '../../index';

export interface ISetProfileAction {
  company: {
    document: string;
    id: number;
    logo: string | null;
    name: string;
    pdfType: EPdfType;
  };
  email: string;
  id: number;
  name: string;
  plan: {
    id: number;
    type: EPlanTypes;
  };
  type: EUserTypes;
}

function setProfile(
  draft: Draft<IAuthData>,
  action: PayloadAction<ISetProfileAction>,
) {
  draft.profile.company.id = action.payload.company.id;
  draft.profile.company.logo = action.payload.company.logo;
  draft.profile.company.name = action.payload.company.name;
  draft.profile.company.pdfType = action.payload.company.pdfType;
  draft.profile.company.document = action.payload.company.document;
  draft.profile.email = action.payload.email;
  draft.profile.id = action.payload.id;
  draft.profile.name = action.payload.name;
  draft.profile.plan = action.payload.plan;
  draft.profile.type = action.payload.type;
}

export default setProfile;
